/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  testing:true,
    BASE_URL : "https://testvalhallamasterapi.examroom.ai:4433/",
    BASE_URL_PROCTOR : "https://testvalhallaproctorconsoleapi.examroom.ai:4438/",   
    BASE_URL_SCHEDULER : "https://testvalhallaschedulerapi.examroom.ai:4439/",
    API_CRM : "https://testvalhallacrmapi.examroom.ai:4431/",
    MICRO_SERVICE_URL : "https://testproctorconsolemicroservice.examroom.ai:4434",
    SCHEDULER_URL : "https://testschedulerui.examroom.ai:4444/",
};
